import { Helmet } from "react-helmet";
import Navbar from "../../../../components/Navbar/Navbar";
import WhatsAppWidget from "../../../../components/Navbar/Whatsapp";
import Banner from "../../../../components/body/projectPageComponents/Banner";
import Overview from "../../../../components/body/projectPageComponents/Overview";
import Pricing from "../../../../components/body/projectPageComponents/Pricing";
import Gallery from "../../../../components/body/projectPageComponents/Gallery";
import Location from "../../../../components/body/projectPageComponents/Location";
import Highlights from "../../../../components/body/projectPageComponents/Highlights";
import SiteVisitBanner from "../../../../components/body/projectPageComponents/SiteVisitBanner";
import FloorPlans from "../../../../components/body/projectPageComponents/FloorPlans";
import Amenities from "../../../../components/body/projectPageComponents/Amenities";
import Faq from "../../../../components/body/projectPageComponents/Faq";
import SimilarProject from "../../../../components/body/projectPageComponents/SimilarProject";

import { projectsmantri } from "../../../../data/projects/mantri/data";

export const MantriEnergia = () => {
  const {
    energia: {
      form_data,
      whatsapp,
      bannerdata,
      overview,
      sitevisit,
      pricing,
      floor_plan,
      highlights,
      location,
      gallery,
      faq,
      similar
    }
  } = projectsmantri;

  return (
    <>
      <Helmet>
        <title>Mantri Energia, Hebbal, Bengaluru – Luxury 2 & 3 BHK Apartments</title>

        <meta
          name="description"
          content="Explore Mantri Energia in Hebbal, Bengaluru – premium 2 & 3 BHK apartments with world-class amenities, lush green surroundings, and excellent connectivity. Invest in your dream home today!"
        />

        <meta
          name="keywords"
          content="Mantri Energia Hebbal, Mantri Energia Bengaluru, Mantri Energia 2 BHK, Mantri Energia 3 BHK, luxury apartments in Hebbal, Mantri Energia price"
        />

        <link
          rel="canonical"
          href="https://propertystation.in/mantri-energia-hebbal-bengaluru"
        />

        <meta
          name="robots"
          content="index, follow"
        />

      </Helmet>

      <WhatsAppWidget whatsappdata={whatsapp} />
      <Navbar />

      <div className="mt-20">
        <Banner
          bannerDesktopImage={bannerdata.bannerDesktopImage}
          bannerMobileImage={bannerdata.bannerMobileImage}
          data={bannerdata.data}
          formData={form_data}
        />
        <Overview overviewData={overview} stripdata={overview.stripdata} />
        <SiteVisitBanner image={sitevisit.image} formData={form_data} />
        <Pricing pricingData={pricing} formData={form_data} />
        <FloorPlans floorPlans={floor_plan} formData={form_data} />
        <Highlights hightlightData={highlights} formData={form_data} />
        <Amenities />
        <Location location={location} />
        <Gallery galleryData={gallery} />
        <Faq faqdata={faq} />
        <SimilarProject Similarprojects={similar} />
      </div>
    </>
  );
};
